import type { ClipboardEvent } from "react"

const COUNTRY_CODE = "998"
const NATIONAL_LENGTH = 9

export function normalizeUzPhone(input: string | undefined | null = "") {
  const digits = String(input ?? "").replace(/\D/g, "")

  const national =
    digits.length > NATIONAL_LENGTH && digits.startsWith(COUNTRY_CODE)
      ? digits.slice(COUNTRY_CODE.length)
      : digits

  return national.slice(0, NATIONAL_LENGTH)
}

export function formatUzPhone(input: string | undefined | null = "") {
  const digits = normalizeUzPhone(input)
  if (!digits) return ""

  let value = `+${COUNTRY_CODE} (${digits.slice(0, 2)}`
  if (digits.length > 2) value += `) ${digits.slice(2, 5)}`
  if (digits.length > 5) value += `-${digits.slice(5, 7)}`
  if (digits.length > 7) value += `-${digits.slice(7, 9)}`

  return value
}

export function handlePhonePaste(event: ClipboardEvent<HTMLInputElement>) {
  const input = event.target as HTMLInputElement
  const pasted = event.clipboardData?.getData("text") ?? ""
  const digits = normalizeUzPhone(pasted)

  if (!input || !digits) return

  event.preventDefault()

  const value = formatUzPhone(digits)
  const setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set
  setValue?.call(input, value)
  input.setSelectionRange(value.length, value.length)
  input.dispatchEvent(new Event("input", { bubbles: true }))
}
